/* GRP UK recent searches (snippets/search-popup.liquid).
   Remembers the visitor's last searches on their own device (localStorage only,
   nothing is sent anywhere) and shows them as chips in the search pop-up.
   A search is remembered when the results page loads (/search?q=...) or when a
   pop-up result is clicked. Some templates render more than one pop-up, so
   every [data-grp-rsearch] box is wired up with the input next to it. */
(function () {
  var KEY = 'grp_recent_searches';
  var MAX = 8;
  var boxes = [];

  function read() {
    try {
      var list = JSON.parse(localStorage.getItem(KEY) || '[]');
      return Array.isArray(list) ? list.filter(function (q) { return typeof q === 'string'; }) : [];
    } catch (e) {
      return [];
    }
  }

  function write(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list.slice(0, MAX))); } catch (e) {}
    renderAll();
  }

  function remember(q) {
    q = (q || '').replace(/\s+/g, ' ').trim().slice(0, 60);
    if (q.length < 2) return;
    var lower = q.toLowerCase();
    write([q].concat(read().filter(function (x) { return x.toLowerCase() !== lower; })));
  }

  function forget(q) {
    write(read().filter(function (x) { return x !== q; }));
  }

  function toggle(box, input) {
    var typing = input && input.value.trim() !== '';
    box.hidden = typing || read().length === 0;
  }

  function render(box, input) {
    var items = box.querySelector('[data-grp-rsearch-items]');
    if (!items) return;
    items.textContent = '';
    read().forEach(function (q) {
      var chip = document.createElement('span');
      chip.className = 'grp-rsearch__chip';
      var go = document.createElement('button');
      go.type = 'button';
      go.className = 'grp-rsearch__q';
      go.textContent = q;
      go.addEventListener('click', function () {
        if (!input) return;
        input.value = q;
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.focus();
        toggle(box, input);
      });
      var x = document.createElement('button');
      x.type = 'button';
      x.className = 'grp-rsearch__x';
      x.setAttribute('aria-label', 'Remove "' + q + '" from recent searches');
      x.innerHTML = '<svg viewBox="0 0 24 24" width="12" height="12" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"/></svg>';
      x.addEventListener('click', function () {
        forget(q);
        if (input) input.focus();
      });
      chip.appendChild(go);
      chip.appendChild(x);
      items.appendChild(chip);
    });
    toggle(box, input);
  }

  function renderAll() {
    boxes.forEach(function (b) { render(b.box, b.input); });
  }

  function wire(box) {
    if (box.hasAttribute('data-ready')) return;
    box.setAttribute('data-ready', '');
    var root = box.closest('[data-search-popup]') || document;
    var input = root.querySelector('[data-search-input]');
    boxes.push({ box: box, input: input });

    var clearAll = box.querySelector('[data-grp-rsearch-clear]');
    if (clearAll) {
      clearAll.addEventListener('click', function () {
        write([]);
        if (input) input.focus();
      });
    }
    if (!input) return;
    input.addEventListener('input', function () { toggle(box, input); });
    var clear = input.form && input.form.querySelector('[data-clear-search]');
    if (clear) clear.addEventListener('click', function () { setTimeout(function () { toggle(box, input); }, 0); });
    // Clicking a suggestion, product or collection in the pop-up counts as a search.
    var panel = root.querySelector('[data-search-results-panel]');
    if (panel) {
      panel.addEventListener('click', function (e) {
        if (e.target.closest('a, button[type="submit"]')) remember(input.value);
      });
    }
    if (input.form) input.form.addEventListener('submit', function () { remember(input.value); });
  }

  // Results page: remember what was searched for.
  if (/^\/search\/?$/.test(location.pathname)) {
    var q = new URLSearchParams(location.search).get('q');
    if (q) remember(q);
  }

  document.querySelectorAll('[data-grp-rsearch]').forEach(wire);
  renderAll();
  window.addEventListener('storage', function (e) { if (e.key === KEY) renderAll(); });
})();
